import { FullscreenExitOutlined, FullscreenOutlined, ToolOutlined } from '@ant-design/icons';
import React, { FC, useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { useNavigate } from 'react-router-dom';
import { ShareDataContext } from '../..';
import { Select } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import { apiV2MicrogridResolvedGetMicrogridConfigListPost } from '@maxtropy/intelligent-dispath-apis-v2';

interface IHeaderProps {
  fullBtn: () => void;
  isFullScreen: boolean;
}

const Header: FC<IHeaderProps> = props => {
  const { fullBtn, isFullScreen } = props;
  const context = useContext(ShareDataContext);
  const navigate = useNavigate();

  // 查询微电网
  const { data: microgridsList } = useRequest(() =>
    apiV2MicrogridResolvedGetMicrogridConfigListPost({}).then(res => {
      return res?.list ?? [];
    })
  );

  // 默认选择第一个微电网
  useEffect(() => {
    if (!microgridsList || microgridsList.length === 0) {
      context.setMicrogridId?.(undefined);
    } else {
      context.setMicrogridId?.(microgridsList?.[0].configId);
    }
  }, [microgridsList]);

  return (
    <div className={styles.header_area_box}>
      <div className={styles.date_box}>
        <span>微电网：</span>
        <Select
          style={{ width: 200 }}
          value={context.microgridId}
          onChange={v => {
            context.setMicrogridId?.(v);
          }}
          options={(microgridsList ?? []).map(item => ({
            label: item.displayName,
            value: item.configId,
          }))}
          showSearch
          optionFilterProp="label"
          placeholder="请选择"
          getPopupContainer={(triggerNode: HTMLElement) => triggerNode.parentNode as HTMLElement}
        />
      </div>
      <div className={styles.title_box}>
        <span className={styles.text}>
          {microgridsList?.find(i => i.configId === context.microgridId)?.displayName}
        </span>
      </div>
      <div className={styles.set_box}>
        <div className={styles.btn} onClick={fullBtn}>
          {isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
          &nbsp;
          <span className={styles.text}>{isFullScreen ? '退出' : '全屏'}</span>
          <div className={styles.bottomLine} />
        </div>
      </div>
    </div>
  );
};

export default Header;
